var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 0H7.875C6.63398 0 5.625 1.00723 5.625 2.25V10.125C5.625 11.3678 6.63223 12.375 7.875 12.375H15.75C16.9928 12.375 18 11.3678 18 10.125V2.25C18 1.00723 16.991 0 15.75 0ZM16.3125 10.125C16.3125 10.4351 16.0601 10.6875 15.75 10.6875H7.875C7.56563 10.6875 7.3125 10.4344 7.3125 10.125V2.25C7.3125 1.93985 7.56485 1.6875 7.875 1.6875H15.75C16.0601 1.6875 16.3125 1.93985 16.3125 2.25V10.125ZM10.6875 15.75C10.6875 16.0601 10.4351 16.3125 10.125 16.3125H2.25C1.93985 16.3125 1.6875 16.0601 1.6875 15.75V7.875C1.6875 7.56485 1.93985 7.3125 2.25 7.3125H4.5V5.625H2.25C1.00723 5.625 0 6.63398 0 7.875V15.75C0 16.9928 1.00723 18 2.25 18H10.125C11.3678 18 12.375 16.9928 12.375 15.75V13.5H10.6875V15.75Z",
    fill: "#2A1B5B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.230811399dd29fb9206276e13a2e1ec9.svg";
export { ForwardRef as ReactComponent };